import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6fc3e4c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative size-full px-1" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }

import {
  computed,
} from 'vue';
import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageList',
  setup(__props) {

const conversationThreadStore = computed(() => useStore.conversationThread);

function formattedResponse(response: string): string {
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Replace URL with an HTML anchor tag
  const clickableResponse = response.replace(
    urlRegex,
    (url) => `<a 
      href="${url}"
      class="text-blue-600 underline px-1 rounded-md hover:bg-gray-300" 
      target="_blank"
    >
      ${url}
    </a></br>`,
  );

  return clickableResponse;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conversationThreadStore.value.messages, (message, messageIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        key: message.content + messageIndex,
        class: _normalizeClass(["flex items-center overflow-hidden p-2 md:px-4", {
        'justify-start': message.type === 'receiver',
        'justify-end': message.type === 'sender',
      }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-md break-words font-normal", {
          receiver: message.type === 'receiver',
          sender: message.type === 'sender',
        }])
        }, [
          (message.type === 'receiver')
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                innerHTML: formattedResponse(message.content)
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(message.content), 1))
        ], 2)
      ], 2))
    }), 128))
  ]))
}
}

})